export const formatEuro = (value) => {
  const number = Number(value) || 0;
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  }).format(number);
};
